import React, { useState, useEffect } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import validate from "validate.js";
import { bindUsersToProgram } from "actions";
import { UserDropdown } from "CommonDropdowns";
import AddNewUserModal from "../AddNewUserModal";

const schema = {
  users: {
    presence: { allowEmpty: false, message: "^At least one user is required" },
  },
};

const AddUserModal = ({ show, handleClose, programId }) => {
  const dispatch = useDispatch();
  const [showCreateModal, setShowCreateModal] = useState(false);

  const session = useSelector((s) => s.session);
  
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      users: [],
    },
    touched: {},
    errors: {},
  });

  useEffect(() => {
    const errors = validate(formState.values, schema);
    setFormState((formState) => ({
      ...formState,
      isValid: !errors,
      errors: errors || {},
    }));
  }, [formState.values]);

  const handleUserChange = (selected) => {
    setFormState((formState) => ({
      ...formState,
      values: {
        ...formState.values,
        users: selected,
      },
      touched: {
        ...formState.touched,
        users: true,
      },
    }));
  };

  const handleBindUsers = (event) => {
    event.preventDefault();
    const userIds = formState.values.users.map((item) => item.value);
    let data = {
      user_ids: userIds,
      object_viewed_id: object_viewed_id,
    }

    if (formState.isValid) {
      dispatch(bindUsersToProgram(programId, data, onModelClose));
    }
  };

  const hasError = (field) =>
    formState.touched[field] && formState.errors[field] ? true : false;

  const onModelClose = () => {
    handleClose();
    setFormState({
      isValid: false,
      values: { users: [] },
      touched: {},
      errors: {},
    });
  };

  const handleOpenCreate = () => {
    setShowCreateModal(true);
  };

  const handleCloseCreate = () => {
    setShowCreateModal(false);
  };

  return (
    <>
      <Modal show={show} onHide={onModelClose} centered className="add-new-program">
        <div className="p-2">
          <Modal.Header className="p-2" closeButton>
            <Modal.Title>
              <h5 className="font-20 font-weight-bold heading-color">
                Add User
              </h5>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form onSubmit={handleBindUsers}>
              <UserDropdown
                isMulti
                userValue={formState.values.users}
                userOnChange={handleUserChange}
                showSelectAllOption={false}
                programId={programId}
              />
              {hasError("users") && (
                <div className="invalid-feedback d-block">
                  {formState.errors.users[0]}
                </div>
              )}

              <Row className="mt-3">
                <Col lg={6}>
                  <button className="c-b-btn w-100" onClick={onModelClose}>
                    Cancel
                  </button>
                </Col>
                <Col lg={6}>
                  <button className="n-u-btn w-100" onClick={handleBindUsers} disabled={!formState.isValid}>
                    Update
                  </button>
                </Col>
              </Row>
            </Form>
          </Modal.Body>

          <Modal.Footer className="justify-content-center">
            {/*<a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleClose();
                handleOpenCreate();
              }}
              className="font-12 font-weight-s-bold heading-color"
            >
              Can’t find a User? Add a new one here.
            </a>*/}
          </Modal.Footer>
        </div>
      </Modal>

      <AddNewUserModal show={showCreateModal} handleClose={handleCloseCreate} />
    </>
  );
};

export default AddUserModal;
